import { useContext } from 'react'
import GoogleArc from '../googleMap/arc'
import MapboxArc from '../mapbox/arc'
import { MapContext } from './mapContext'

import { FeatureCollectionWithInfoAndStyle } from '~/components/mapContent/utils/geoAndStatsToFeatureCollection'

interface ArcProps {
  geoJson: FeatureCollectionWithInfoAndStyle
  origin?: 'previous' | 'first'
  widthMultiplier?: number
}

export default function Arc<T>(props: ArcProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('Arc must be used within a map')
  }

  const { mapProvider } = mapContext

  let layerJSXElement: JSX.Element
  if (mapProvider === 'google') {
    layerJSXElement = <GoogleArc {...props} />
  } else if (mapProvider === 'mapbox') {
    layerJSXElement = <MapboxArc {...props} />
  } else {
    throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
